import type { OnboardingNudgeKey } from '@wundo/shared/onboardingNudge.ts';
import { m } from '@/paraglide/messages.js';

export interface ChatNudgeCopy {
  /** What it is about, in a couple of words. */
  title: string;
  /** Why it is worth doing, in one sentence. */
  body: string;
  /** The words on the one button. */
  action: string;
}

/**
 * What a nudge says, in the reader's own language.
 *
 * Written here rather than by the server: none of it depends on the user's
 * data — the backend answers which nudge, and the sentences around that answer
 * are ordinary interface copy like every other line in the drawer.
 */
export function chatNudgeCopy(key: OnboardingNudgeKey): ChatNudgeCopy {
  switch (key) {
    case 'plan_first_meeting':
      return {
        title: m.nudge_plan_first_meeting_title(),
        body: m.nudge_plan_first_meeting_body(),
        action: m.nudge_plan_first_meeting_action(),
      };
    case 'try_library_roleplay':
      return {
        title: m.nudge_try_library_roleplay_title(),
        body: m.nudge_try_library_roleplay_body(),
        action: m.nudge_try_library_roleplay_action(),
      };
    case 'rehearse_this_meeting':
      return {
        title: m.nudge_rehearse_this_meeting_title(),
        body: m.nudge_rehearse_this_meeting_body(),
        action: m.nudge_rehearse_this_meeting_action(),
      };
    case 'ask_conversation_tips':
      return {
        title: m.nudge_ask_conversation_tips_title(),
        body: m.nudge_ask_conversation_tips_body(),
        action: m.nudge_ask_conversation_tips_action(),
      };
    case 'enable_notetaker':
      return {
        title: m.nudge_enable_notetaker_title(),
        body: m.nudge_enable_notetaker_body(),
        action: m.nudge_enable_notetaker_action(),
      };
    case 'ask_meeting_feedback':
      return {
        title: m.nudge_ask_meeting_feedback_title(),
        body: m.nudge_ask_meeting_feedback_body(),
        action: m.nudge_ask_meeting_feedback_action(),
      };
    case 'upload_person_document':
      return {
        title: m.nudge_upload_person_document_title(),
        body: m.nudge_upload_person_document_body(),
        action: m.nudge_upload_person_document_action(),
      };
  }
}
